export class PadNotFoundError extends Error {
	name = "PadNotFoundError";
}